import { render } from "./FormSearch.vue?vue&type=template&id=6b4f375a&scoped=true"
import script from "./FormSearch.vue?vue&type=script&lang=js"
export * from "./FormSearch.vue?vue&type=script&lang=js"

import "./FormSearch.vue?vue&type=style&index=0&id=6b4f375a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4f375a"]])

export default __exports__